import BaseClient from './baseClient';

class OpenSearchIndexesClient extends BaseClient {
  async getAllIndexes(): Promise<OpenSearchIndexesListResponse> {
    return this.fetch('/searchops/indexes/v1');
  }

  async executeQuery(
    generationEndpoint: string,
    queryPath: string,
    body?: string,
    method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'HEAD' = 'GET',
  ): Promise<any> {
    const url = `/searchops/query/v1`;
    return this.fetch(url, {
      method: 'POST',
      body: JSON.stringify({
        method,
        generationEndpoint,
        queryPath,
        body: body || null,
      }),
    });
  }
}

export default new OpenSearchIndexesClient();
